var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.358 2C7.46498 1.99937 3.29386 5.54799 2.51045 10.3779C1.72703 15.2079 4.56264 19.893 9.20505 21.439C9.70505 21.529 9.88405 21.222 9.88405 20.958C9.88405 20.721 9.87605 20.093 9.87305 19.258C7.09805 19.858 6.51205 17.92 6.51205 17.92C6.32936 17.3169 5.93662 16.7993 5.40505 16.461C4.50505 15.842 5.47405 15.856 5.47405 15.856C6.11472 15.9438 6.6786 16.3235 7.00105 16.884C7.27398 17.3803 7.73381 17.747 8.27835 17.9026C8.8229 18.0583 9.40706 17.99 9.90105 17.713C9.94747 17.207 10.1726 16.7341 10.536 16.379C8.32205 16.128 5.99405 15.272 5.99405 11.449C5.98176 10.4602 6.34895 9.5043 7.02005 8.778C6.7164 7.91731 6.75216 6.97325 7.12005 6.138C7.12005 6.138 7.95705 5.869 9.86205 7.159C11.4959 6.71101 13.2202 6.71101 14.854 7.159C16.76 5.868 17.596 6.138 17.596 6.138C17.9656 6.97286 18.0014 7.91757 17.696 8.778C18.3696 9.50423 18.7365 10.4626 18.72 11.453C18.72 15.286 16.39 16.128 14.168 16.375C14.6474 16.8651 14.8932 17.5373 14.843 18.221C14.843 19.555 14.831 20.631 14.831 20.958C14.831 21.225 15.009 21.535 15.518 21.437C20.1585 19.8884 22.9911 15.203 22.2061 10.3743C21.421 5.54565 17.2501 1.99888 12.358 2Z",
    fill: "#57606A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/Github.2745ded6f831003a8584a24ccdd5d013.svg";
export { ForwardRef as ReactComponent };